<fs-sidenav-menu-items>
  @if (environment && hasSettingsAccess) {
    <a
      fs-sidenav-menu-item
      [routerLink]="['/workspace/',environment.id,'settings']"
      (click)="close()">
      Settings
    </a>
  }
  @if (hasAdminWritePermissions) {
    <a
      fs-sidenav-menu-item
      (click)="create()"
      >
      Create New Workspace
    </a>
  }
  <a
    fs-sidenav-menu-item
    (click)="switch()">
    Switch Workspace
  </a>
</fs-sidenav-menu-items>